import React, { useState } from 'react';
import { Button, Modal, Col, Form, Row } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { useFirebase } from '../../../contexts/FirebaseContext';

const DeleteLesson = ({ track, session, fundamental }) => {
  const [showDeleteLesson, setShowDeleteLesson] = useState(false);
  const { deleteLesson } = useFirebase();

  const { register, reset, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    await deleteLesson(track, session, fundamental, data.lesson)
      .then(reset())
      .then(() => {
        toast.success(`${data.lesson} has been deleted!`, {
          duration: 2000,
          icon: '👏',
        });
      })
      .then(
        setTimeout(() => {
          window.location.reload();
        }, 2000)
      )
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          className='btn-danger ml-2 mt-2 mb-2'
          onClick={() => setShowDeleteLesson(true)}
        >
          Delete Lesson
        </Button>
      </div>

      <Modal
        size='md'
        data-backdrop='static'
        data-keyboard='false'
        animation={true}
        show={showDeleteLesson}
        onHide={() => setShowDeleteLesson(!showDeleteLesson)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Lesson</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {/* Lesson */}
                <Form.Label>Lesson</Form.Label>
                <Form.Group controlId='formDeleteLesson'>
                  <Form.Control
                    type='text'
                    name='lesson'
                    placeholder='What lesson?'
                    ref={register({ required: true })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button className='w-25' variant='danger' type='submit'>
                  Delete
                </Button>
                <Toaster />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteLesson;
